import React, { useState } from 'react';
import ReactTableGenericForUsers from 'Components/ReactTableGenericForUsers';
import { Card, CardBody } from 'reactstrap';
import GroupStatus from "../../../../../Components/IconDropdown/Cross_Tick/GroupStatus";
import SchoolStatusChangeModal from "Components/Modal/SchoolStatusChangeModal";

import { toast } from 'react-toastify';
import { useToggleSchoolStatus } from 'Api/Admin/Besturen/Scholen';

const Scholen = ({ data, handleSchoolClick, communityId, setSearchValue, setPageNumber, toggle, pageNumber, paginate, userTablePageSize, pageSizeCount, totalPageCount,totalCount, showLoader, tableData, mutateSchools }) => {

    const [statusToChange, setStatusToChange] = useState(null);
    const [showStatusModal, setShowStatusModal] = useState(false);

    const { trigger: toggleSchoolStatus } = useToggleSchoolStatus();

    const handleToggle = (field, newValue, schoolId) => {
        const school = tableData.find(s => s.iSchoolId === schoolId);
        if (!school) return;

        const currentStatus = school.eStatus === "Active";
        const newStatus = newValue === "1";

        if (currentStatus && !newStatus) {
            setStatusToChange({
                schoolId,
                schoolName: school.vSchoolName,
                newStatus: "Inactive"
            });

            setShowStatusModal(true);
        } else if (!currentStatus && newStatus) {
            handleIconFieldChange(field, "1", schoolId);
        }
    };


    const confirmStatusChange = () => {
        if (!statusToChange) return;

        const { schoolId } = statusToChange;

        handleIconFieldChange("eStatus", "0", schoolId);
        setShowStatusModal(false);
        setStatusToChange(null);
    };

    const cancelStatusChange = () => {
        setShowStatusModal(false);
        setStatusToChange(null);
    };


    const columns = [
        {
            header: "School",
            accessorKey: "vSchoolName",
            cell: value => {
                return (
                    <div className='svg-pointer' onClick={() => handleSchoolClick("update", value.row.original)} >
                        {value.row.original.vSchoolName}
                    </div>
                );
            },
        },
        {
            header: "Plaats",
            accessorKey: "vVisitcity",
            cell: value => {
                return (
                    <div className="" >
                        {value.row.original.vVisitcity}
                    </div>
                );
            },
        },
        {
            header: <div className="text-center font-weight-bold">Actief</div>,
            accessorKey: "iSchoolId",
            cell: ({ row }) => {
                const rowData = row.original;
                const schoolId = rowData.iSchoolId;
                const isActive = rowData.eStatus === "Active";

                return (
                    <div className="d-flex justify-content-center">
                        <GroupStatus
                            iconChangeHandler={(field, data) => handleToggle(field, data, schoolId)}
                            field="eStatus"
                            data={isActive ? 1 : 0}
                        />
                    </div>
                );
            },
        }
    ];

    const handleIconFieldChange = (field, value, id, removeLoading) => {
        toggleSchoolStatus({
            data: {

                iCommunityId: data?.iCommunityId,
                iSchoolId: id,
                eStatus: value === "1"
                    ? "Active"
                    : "Inactive",
            }
        }).then((response) => {
            
            if (response?.status) {
                mutateSchools();
            } else {
                toast.error("Kan niet updaten.");
                toggle();
            }
        }).catch((error) => {
            toggle();
            console.error(error);
            toast.error("Kan niet updaten.");
        })
    };
    const filterList = (val) => {
        handleInputChange(val);
    }

    const handleInputChange = (val) => {
        setPageNumber(1);
        setSearchValue(val);
    };
    return (
        <>
            <Card className="main-card pb-5">
                <CardBody className="d-flex flex-column">
                    <ReactTableGenericForUsers
                        data={tableData}
                        columns={columns}
                        userTablePageSize={userTablePageSize}
                        filterList={filterList}
                        totalPageCount={totalPageCount}
                        paginate={paginate}
                        pageNumber={pageNumber}
                        setPageNumber={setPageNumber}
                        pageSizeCount={pageSizeCount}
                        showLoader={showLoader}
                        tableClassName="mb-0 table table-borderless table-sm table-hover"
                        count={totalCount}

                    />
                </CardBody>
            </Card >
            <SchoolStatusChangeModal
                isOpen={showStatusModal}
                onConfirm={confirmStatusChange}
                onCancel={cancelStatusChange}
                school={statusToChange?.schoolName}
            />

        </>
    );
};

export default Scholen;